import React, { useEffect, useState } from 'react'
import BarcodeGenerator from '@components/Barcode/index'
import moment from 'moment'
import { useQuery } from '@tanstack/react-query'
import { fetchSalesOrderByDocEntry } from '@utils/fetchData'
import { Spin, Table, Image } from 'antd'
import { config } from '../../config'
import { Empty } from 'antd'
import { http } from '@services/http.js'
import { generateImage } from '@utils/generateShapeImage'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import Oval from '@assets/images/Shapes/Pencil.png'

const MarshrutPageForWorkers = () => {
	const [docEntry, setDocEntry] = useState(null)
	const [selectedImage, setSelectedImage] = useState(null)
	const [imageKeys, setImageKeys] = useState('')

	const fetchImagesWithKeys = async ({ queryKey }) => {
		const [_, keys] = queryKey
		if (keys) {
			try {
				let url = `api/assets/multiple/${keys}`
				const { data } = await http.get(url)
				console.log(data)
				return data
			} catch (error) {
				console.log(error)
			}
		}
	}

	const fetchProductionsForOneSale = async ({ queryKey }) => {
		const [_, docEntry] = queryKey
		try {
			let url = `api/pots/get-pots-lines?isDelivered=Y&salesOrderDocEntry=${docEntry}&skip=0&pageSize=1000`
			const { data } = await http.get(url)
			return data
		} catch (error) {
			console.log(error)
		}
	}

	useEffect(() => {
		const storedData = localStorage.getItem('marshrutDocEntry')
		if (storedData) {
			setDocEntry(JSON.parse(storedData))
			console.log('docEntry = ', JSON.parse(storedData))
		}
	}, [])

	const { data: productionData = [] } = useQuery({
		queryKey: ['productions', docEntry],
		queryFn: fetchProductionsForOneSale,
		keepPreviousData: false,
		refetchOnWindowFocus: true,
		enabled: !!docEntry,
	})

	useEffect(() => {
		setTimeout(() => {
			window.print()
		}, 1000)
	}, [])

	const { data = [], isLoading } = useQuery({
		queryKey: ['marshrut', docEntry],
		queryFn: fetchSalesOrderByDocEntry,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const { data: images = [] } = useQuery({
		queryKey: ['images', imageKeys],
		queryFn: fetchImagesWithKeys,
		keepPreviousData: false,
		refetchOnWindowFocus: true,
	})

	useEffect(() => {
		if (data?.u_ChertejId) {
			const photoId = data?.u_ChertejId
			setImageKeys(photoId)
		}
	}, [data])

	if (isLoading) {
		return (
			<div className="flex h-screen w-full items-center justify-center">
				<Spin size="large" />
			</div>
		)
	}

	if (!data || !data?.documentLines) {
		return null
	}

	return (
		<div className="print-container p-2 bg-white font-semibold text-black font-sans">
			<div className="border-b ">
				<div className="flex justify-between items-center">
					<div className="flex flex-col gap-2">
						<p className="font-semibold text-2xl text-center">
							BUYURTMA № {data?.docNum}
						</p>
						<div className="text-sm">
							<span className="font-semibold">Menejer:</span>{' '}
							{data?.slpName}
						</div>
					</div>
					<div>
						<BarcodeGenerator
							docNum={data?.docNum}
							height={35}
							width={1.5}
							fontSize={14}
							margin={20}
						/>
					</div>
				</div>

				<div className="flex items-center gap-5 justify-between mb-5 text-sm w-full">
					<div className=" flex flex-col gap-2">
						<p className="font-semibold ">
							Buyurtma haqida ma'lumot
						</p>
						<p>
							<span>Sana: </span>
							{moment(data?.docDate).format('DD.MM.YYYY')}
							<span> / Muddati:</span>{' '}
							{moment(data?.docDueDate).format('DD.MM.YYYY')}
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<p className="mt-2 font-semibold text-right">
							Xaridor haqida ma'lumot
						</p>
						<p className="text-right">
							<span>F.I.SH: </span>
							{data?.cardName}
						</p>
					</div>
				</div>
			</div>

			{/* Oyna pozitsiyalari */}
			<div className="mb-6 mt-5">
				<h2 className="text-center font-semibold mb-2 text-lg">
					Oyna pozitsiyalari
				</h2>
				<table className="w-full border-collapse border border-gray-400">
					<thead>
						<tr className="print:bg-[#364152] text-white font-semibold text-[12px]    bg-[#364152]  print-bg-color">
							<th className="border border-gray-400 px-2 py-1">
								№
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Tovar nomi
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Xizmatlar
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Eni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Bo'yi
							</th>

							<th className="border border-gray-400 px-2 py-1">
								Buyurtma Miqdori
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kv.m
							</th>

							<th className="border border-gray-400 px-2 py-1">
								Mavjud miqdori
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kg
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Jo'natilgan miqdori
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Jo'natilgan kg
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.documentLines
							?.filter((item, idx) => {
								return item.u_Produkt === null
							})
							?.sort((a, b) => a.lineNum - b.lineNum) // Sort by lineNum in ascending order
							?.map((item, idx) => {
								return (
									<tr className=" font-semibold text-sm   print-bg-color">
										<td className="border border-gray-400  px-2 py-1 text-center">
											{idx + 1}
										</td>
										<td className="border border-gray-400  px-2 py-1 min-w-[100px]">
											{item.itemDescription}
										</td>
										<td className="border border-gray-400 px-2 py-1">
											<span>
												{data?.documentLines
													?.filter((oneItem) => {
														return (
															oneItem.u_Produkt !==
																null &&
															oneItem.u_Produkt ===
																item.itemDescription &&
															oneItem.u_uslugaID ===
																item.u_uslugaID &&
															oneItem.u_ItemGroup !==
																'Shape'
														)
													})
													.sort(
														(a, b) =>
															(a.u_Number ?? 0) -
															(b.u_Number ?? 0),
													)
													?.map(
														(
															oneItem,
															idx,
															array,
														) => {
															const isLast =
																idx ===
																array.length - 1
															return (
																<span key={idx}>
																	{`${oneItem.u_Number ?? ''} ${oneItem.itemDescription}`}
																	{isLast
																		? ''
																		: ', '}
																</span>
															)
														},
													)}
												{/* <div className="flex gap-2">
													{data?.documentLines
														.filter((oneItem) => {
															return (
																oneItem.u_Produkt !==
																	null &&
																oneItem.u_Produkt ===
																	item.itemDescription &&
																oneItem.u_uslugaID ===
																	item.u_uslugaID &&
																oneItem.u_ItemGroup ===
																	'Shape'
															)
														})
														.map((oneItem, idx) => {
															return (
																<span key={idx}>
																	<img
																		src={generateImage(
																			oneItem.itemCode,
																		)}
																		alt="service"
																		style={{
																			width: '50px',
																			// height: '50px',
																		}}
																	/>
																</span>
															)
														})}
												</div> */}
											</span>
										</td>
										<td className="border text-center border-gray-400  px-2 py-1 ">
											{`${item.u_Width}`}
										</td>
										<td className="border text-center border-gray-400  px-2 py-1 ">
											{`${item.u_Height}`}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.u_PlannedQuantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.quantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.openQuantitySon}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{new Intl.NumberFormat(
												'fr-FR',
											).format(
												item.u_Kg &&
													+item.u_Kg * item.quantity,
											) || ''}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.shippedQuantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{new Intl.NumberFormat(
												'fr-FR',
											).format(
												item.u_Kg &&
													+item.u_Kg *
														item.quantity *
														item.shippedQuantity,
											) || ''}
										</td>
									</tr>
								)
							})}
					</tbody>
					<tfoot>
						<tr className="print:bg-[#364152] text-white font-semibold text-[12px] bg-[#364152]  print-bg-color">
							<td
								className="border border-gray-400 px-2 py-1 text-end font-semibold"
								colSpan={5}
							></td>
							{/* Buyurtma soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${numberWithSpacesIntl(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.u_PlannedQuantity),
											0,
										),
								)} `}
							</td>
							{/* Kv.m  */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total + Number(item.quantity),
											0,
										),
								)} `}
							</td>
							{/* Mavjud soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.openQuantitySon),
											0,
										),
								)} `}
							</td>
							{/* Kg */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												+item.u_Kg * +item.quantity,
											0,
										),
								)} `}
							</td>
							{/* Jo'natilgan soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${numberWithSpacesIntl(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.shippedQuantity),
											0,
										),
								)} `}
							</td>
							{/* Jo'natilgan kg */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${new Intl.NumberFormat('fr-FR').format(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												+item.u_Kg *
													+item.quantity *
													+item.shippedQuantity,
											0,
										),
								)} `}
							</td>
						</tr>
					</tfoot>
				</table>
			</div>

			{/*Pots */}
			<div className="mb-6 mt-5">
				<table className="w-[70%] border-collapse border border-gray-400">
					<thead>
						<tr className="print:bg-[#364152] text-white font-semibold text-[12px]    bg-[#364152]  print-bg-color">
							<th className="border border-gray-400 px-2 py-1">
								№
							</th>
							<th className="border border-gray-400 px-2 py-1 ">
								Tovar nomi
							</th>

							<th className="border border-gray-400 px-2 py-1 ">
								Yub. soni
							</th>
							<th className="border border-gray-400 px-2 py-1 ">
								Yub. seriya raqamlari
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.documentLines
							.filter((item, idx) => {
								return item.u_Produkt === null
							})
							.sort((a, b) => a.lineNum - b.lineNum) // Sort by lineNum in ascending order
							.map((item, idx) => {
								const potsForOneItem = productionData?.filter(
									(pots) => pots.u_uslugaID == item.lineNum,
								)

								console.log('potsForOneItem', potsForOneItem)

								return (
									<tr className=" font-semibold text-sm   print-bg-color">
										<td className="border border-gray-400  px-2 py-1 text-center">
											{idx + 1}
										</td>
										<td className="border border-gray-400  px-2 py-1 min-w-[150px]">
											{item.itemDescription}
										</td>

										<td className="border border-gray-400  px-2 py-1 text-center">
											{item.shippedQuantity}
										</td>
										<td className="border border-gray-400  px-2 py-1 text-center">
											{potsForOneItem.map((pots, idx) => {
												return (
													<span key={idx}>
														{pots.serialNumber},
													</span>
												)
											})}
										</td>
									</tr>
								)
							})}
					</tbody>
					<tfoot>
						<tr className="print:bg-[#364152] text-white font-semibold text-[12px] bg-[#364152]  print-bg-color">
							<td
								className="border border-gray-400 px-2 py-1 text-end font-semibold"
								colSpan={2}
							></td>

							{/* Jo'natilgan soni */}
							<td
								className="border border-gray-400 px-2 py-1 text-center font-semibold"
								colSpan={1}
							>
								{`${numberWithSpacesIntl(
									data?.documentLines
										.filter(
											(item) => item.u_Produkt === null,
										)
										.reduce(
											(total, item) =>
												total +
												Number(item.shippedQuantity),
											0,
										),
								)} `}
							</td>
							<td
								className="border border-gray-400 px-2 py-1 text-end font-semibold"
								colSpan={1}
							></td>
						</tr>
					</tfoot>
				</table>
			</div>

			<div className="flex  gap-10">
				<div className="flex flex-col w-full">
					{/* Xizmatlar */}

					<div className="mb-6">
						<h2 className="text-center font-semibold mb-2 text-lg">
							Xizmatlar
						</h2>
						<table className="w-full border-collapse border border-gray-400 text-sm">
							<thead>
								<tr className="print:bg-[#364152]  text-white font-semibold text-[12px] bg-[#364152]  print-bg-color">
									<th className="border border-gray-400 px-2 py-1">
										№
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Xizmat nomi
									</th>

									<th className="border border-gray-400 px-2 py-1">
										Miqdori
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.documentLines
									?.filter(
										(item) =>
											item.u_Produkt !== null &&
											item.u_ItemGroup === 'Service',
									)
									?.sort((a, b) => a.u_Number - b.u_Number)
									.reduce((acc, item) => {
										const existing = acc.find(
											(entry) =>
												entry.itemCode ===
												item.itemCode,
										)
										if (existing) {
											existing.quantity += item.quantity
										} else {
											acc.push({ ...item })
										}
										return acc
									}, [])
									.map((item, idx) => (
										<tr
											className="font-semibold text-sm print-bg-color"
											key={item.itemCode}
										>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{idx + 1}
											</td>
											<td className="border border-gray-400 px-2 py-1">
												{item.itemDescription}
											</td>
											<td className="border border-gray-400 px-2 py-1 text-center">
												{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${item.ugpCode ?? ''}`}
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>
					{/* Shakllar */}
					<div className="mb-6">
						<h2 className="text-center font-semibold mb-2 text-lg">
							Shakllar
						</h2>
						<table className="w-full border-collapse border border-gray-400 text-sm">
							<thead>
								<tr className="print:bg-[#364152] text-white font-semibold text-[12px]  bg-[#364152]  print-bg-color">
									<th className="border border-gray-400 px-2 py-1">
										№
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Mahsulotga tegishli
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Shakl
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Soni
									</th>
									<th className="border border-gray-400 px-2 py-1">
										Miqdori
									</th>
								</tr>
							</thead>
							<tbody>
								{data?.documentLines
									?.filter((item, idx) => {
										return (
											item.u_Produkt !== null &&
											item.u_ItemGroup === 'Shape'
										)
									})
									?.map((item, idx) => {
										return (
											<tr className=" font-semibold text-sm   print-bg-color">
												<td className="border border-gray-400 px-2 py-1 text-center">
													{idx + 1}
												</td>
												<td className="border border-gray-400 px-2 py-1">
													{item.u_Produkt}
												</td>
												<td className="border border-gray-400 px-2 py-1 ">
													{/* {item.itemDescription} */}
													<img
														src={generateImage(
															item.itemCode,
														)}
														alt="service"
														style={{
															width: '40px',
															height: '40px',
														}}
														className="mt-2"
													/>
												</td>

												<td className="border border-gray-400 px-2 py-1 text-center">
													{item.u_FigureQuantity}
												</td>

												<td className="border border-gray-400 px-2 py-1 text-center">
													{`${new Intl.NumberFormat('fr-FR').format(item.quantity)} ${item.ugpCode ?? ''}`}
												</td>
											</tr>
										)
									})}
							</tbody>
							<tfoot>
								<tr className="print:bg-[#364152] text-white font-semibold text-[12px] bg-[#364152]  print-bg-color">
									<td
										className="border border-gray-400 px-2 py-1 text-start font-semibold"
										colSpan={3}
									>
										{/* {`Jami: ${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !== null,
												)
												.reduce(
													(total, item) =>
														total + item.lineTotal,
													0,
												),
										)} ${data?.docCurrency}`} */}
									</td>
									<td
										className="border border-gray-400 px-2 py-1 text-center font-semibold"
										colSpan={1}
									>
										{`${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !==
															null &&
														item.u_ItemGroup ===
															'Shape',
												)
												.reduce(
													(total, item) =>
														total +
														+item.u_FigureQuantity,
													0,
												),
										)}`}
									</td>
									<td
										className="border border-gray-400 px-2 py-1 text-center font-semibold"
										colSpan={1}
									>
										{`${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !==
															null &&
														item.u_ItemGroup ===
															'Shape',
												)
												.reduce(
													(total, item) =>
														total + +item.quantity,
													0,
												),
										)}`}
									</td>
								</tr>
							</tfoot>
						</table>
					</div>
				</div>
				<div className="w-full">
					{data?.documentLines
						.filter((item, idx) => {
							return (
								item.u_Produkt !== null &&
								item.u_ItemGroup === 'Chizma'
							)
						})
						.map((item, idx) => (
							<img
								src={generateImage(item.itemCode)}
								alt="service"
								style={{
									width: '200px',
									height: '200px',
								}}
								className="mt-2"
							/>
						))}
				</div>
			</div>

			<div className=" border-t pt-2">
				<p className="font-semibold text-sm">
					Izoh: <span>{data?.comments ?? ''}</span>
				</p>
			</div>
			<div className="mt-10">
				{images?.length > 0 && images ? (
					<div>
						{images?.map((image, index) => (
							<div
								key={index}
								className="flex w-full items-start flex-col gap-3 "
							>
								<div className="flex flex-col items-center gap-3 w-full h-full">
									<Image
										width={'100%'}
										height={'100%'}
										sizes="100%"
										src={`${config.baseURL}${image.path}`}
										preview={false}
										placeholder={
											<Image
												preview={false}
												src={`${config.baseURL}${image.path}`}
												width={'100%'}
												height={'100%'}
											/>
										}
									/>
								</div>
							</div>
						))}
					</div>
				) : null}
			</div>
		</div>
	)
}

export default MarshrutPageForWorkers
